<template>
  <div class="learning-path-courses row">
    <div
      v-for="(course, i) in learningPath.courses"
      :key="i"
      class="col-12 mb-3 col-sm-6"
    >
      <div class="card">
        <div class="card-body">
          <ContextMenu
            :id="`course-${course.id}-menu`"
            :items="getContextMenu(course)"
            align="right"
            class="card-menu"
          />
          <div class="card-details">
            <div class="card-title">{{ course.name }}</div>
            <div class="card-subtitle">{{ course.total_hours }} hour(s)</div>
          </div>
        </div>
        <div class="card-footer" :class="`status-${getStatus(course)}`">
          <div class="card-icon">
            <icon :icon="getIcon(course)" class="icon svg-icon" />
          </div>
          <div class="card-footer-text">{{ getLabel(course) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnrollmentMixin from "mixins/Courses/HandlesCourseEnrollment";
import CourseDetailsModal from "../Courses/DetailsModal";
export default {
  mixins: [EnrollmentMixin],
  components: { CourseDetailsModal },
  props: {
    learningPath: { type: Object, required: true },
  },
  methods: {
    getEnrollment(course) {
      if (!course.enrollment || !this.learningPath.enrollment) {
        return null;
      }
      let enrollment = course.enrollments.find((e) => e.learning_path_enrollment_id === this.learningPath.enrollment.id);
      return enrollment ?? null;
    },
    hasEnrollment(course) {
      return !!this.getEnrollment(course);
    },
    getIcon(course) {
      let enrollment = this.getEnrollment(course);
      if (!!enrollment) {
        if (
          enrollment.completion_status == this.$root.constants.COMPLETION_PASSED
        ) {
          return "check";
        }
        if (
          enrollment.completion_status ==
          this.$root.constants.COMPLETION_IN_PROCESS
        ) {
          return "arrow-right";
        }
      }
      return "shopping-cart";
    },
    getStatus(course) {
      let enrollment = this.getEnrollment(course);
      if (!!enrollment) {
        if (
          enrollment.completion_status == this.$root.constants.COMPLETION_PASSED
        ) {
          return "completed";
        }
        if (
          enrollment.completion_status ==
          this.$root.constants.COMPLETION_IN_PROCESS
        ) {
          return "in-process";
        }
        return "purchased";
      }
      return "available";
    },
    getLabel(course) {
      let enrollment = this.getEnrollment(course);
      if (!!enrollment) {
        if (
          enrollment.completion_status == this.$root.constants.COMPLETION_PASSED
        ) {
          return "Completed";
        }
        if (
          enrollment.completion_status ==
          this.$root.constants.COMPLETION_IN_PROCESS
        ) {
          return "In Process";
        }
        return "Purchased";
      }
      return "Available to Enroll";
    },
    getContextMenu(course) {
      let menu = [];
      let enrollment = this.getEnrollment(course);
      if (!!course.can_launch && !!course.launch_url) {
        menu.push({
          label: "Launch",
          action: () => {
            this.goToUrl(course.launch_url, true);
          },
        });
      } else if (!!course.show_prereq_notice) {
        menu.push({
          label: "Launch",
          action: () => {
            this.showPrerequisiteNotice();
          },
        });
      } else if (
        !enrollment &&
        !!this.learningPath.enrollment &&
        !!course.enrollment
      ) {
        menu.push({
          label: "Add to Path",
          action: () => {},
        });
      } else if (
        !enrollment &&
        !!this.learningPath.enrollment &&
        !!course.can_enroll
      ) {
        menu.push({
          label: "Add to Path",
          action: () => {
            this.enrollMyself(course);
          },
        });
      }
      if (!!enrollment && enrollment.completion_status === this.$root.constants.COMPLETION_PASSED) {
          menu.push({
              label: 'Print Certificate',
              action: () => {
                  this.goToRoute("training.courses.enrollments.certificate", {
                      enrollment: course.enrollment.id
                  });
              }
          });
      }
      if (!!course.enrollment) {
        menu.push({
          label: "Purchase Confirmation",
          action: () => {
            this.goToRoute("training.print-receipt", {
              enrollment: course.enrollment.id,
            });
          },
        });
      }
      menu.push({
        label: "View Details",
        action: () => {
          this.viewDetails(course);
        },
      });
      return menu;
    },
    viewDetails(course, tab) {
      tab = tab || "details";
      this.$modal(CourseDetailsModal, { course: course, tab: tab })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>